import { jsonStringify } from '../../../../../domain/openu-provider';

export const toJson = (text: string): string => {

    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G',
        'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'O', 'P', 'Q', 'R', 'S', 'T', 'U',
        'V', 'W', 'X', 'Y', 'Z'];

    const map: Map<string, string> = new Map(); // word --> letter

    const formatted = text.replace(/[|{}]/g, '').trim();

    const rows = formatted.split('\n');

    const result: string[] = [];
    let mapping = '';

    let letterIndex = 0;

    for(const row of rows) {

        let resultItem = '';
        const words = row.split(',').map(item => item.trim());

        for(const word of words) {
            if(map.has(word)) {
                resultItem += map.get(word);
            }
            else{
                const letter = letters[letterIndex];
                letterIndex++;
                map.set(word, letter);
                resultItem += letter;
                mapping += `${ word } = ${ letter } \n`
            }
        }

        result.push(resultItem);
    }

    return `${ jsonStringify(result) }\n\n${ mapping }`;
};